import React, { memo } from "react";
import styles from "./styles.module.css";

const TabButton = memo(
  ({ active, onClick, label, buttonStyle, activeButtonStyle }) => {
    return (
      <div
        className={`${styles["tab-button"]} ${
          buttonStyle ? buttonStyle : styles["tab-button-default"]
        } ${
          active
            ? activeButtonStyle
              ? activeButtonStyle
              : styles["active"]
            : ""
        }`}
        onClick={onClick}
      >
        {label}
      </div>
    );
  }
);

export default TabButton;
